import { and, asc, eq } from "drizzle-orm";
import { branch, dining_table, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { liveBranchFilters, liveDiningTableFilters } from "../live/filters";

export function getBranchesQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(branch)
    .where(and(eq(branch.organization_id, organizationId), ...liveBranchFilters()))
    .orderBy(asc(branch.name));
}

export function getTablesQuery(db: PowerSyncDrizzleDB, organizationId: string, branchId: string) {
  return db
    .select()
    .from(dining_table)
    .where(
      and(
        eq(dining_table.organization_id, organizationId),
        eq(dining_table.branch_id, branchId),
        ...liveDiningTableFilters(),
      ),
    )
    .orderBy(asc(dining_table.sort_order), asc(dining_table.name));
}
